import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../UserContext";
import FullscreenLoader from "../FullscreenLoader";

const HomeRedirect = () => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <FullscreenLoader message="Cargando..." />;
  }

  if (!user?.id) {
    // No autenticado ➔ login
    return <Navigate replace to="/login" />;
  }

  // Si el usuario está autenticado, redirigir al dashboard
  return <Navigate replace to="/modules/Dashboard" />;
};

export default HomeRedirect;
